// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  background: #ede9fe !important;
  min-height: 100vh;
  color: #0f172a;
  padding-bottom: 3rem;
  padding-top: 0;
  margin-top: 0;
}

/* Override any parent container backgrounds */
body,
.app,
.main-content {
  background: #ede9fe !important;
}

html[data-theme="dark"] .home-page {
  background: #02030a;
  color: #e5e7eb;
}

.metrics-section {
  max-width: 1200px;
  margin: 3rem auto;
  padding: 2rem;
  background: #d6c3d9;
  border-radius: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  box-shadow: 0 10px 30px rgba(64, 12, 77, 0.15);
  border: 2px solid #c4b1c7;
}

html[data-theme="dark"] .metrics-section {
  background: #0b1220;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);
  color: #e5e7eb;
}

html[data-theme="dark"] .metric-label {
  color: #a3aab7;
}

html[data-theme="dark"] .metric-value {
  color: #f8fafc;
}

.metric {
  text-align: center;
}

.metric-value {
  font-size: 2.25rem;
  font-weight: 700;
  margin: 0;
  color: #400C4D;
}

.metric-label {
  margin: 0;
  letter-spacing: 0.2em;
  font-size: 0.85rem;
  color: #4c1d95;
}

html[data-theme="dark"] .courses-section {
  background: #05060c;
}

.section-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
}

.section-heading h2 {
  margin: 0 0 0.75rem;
  font-size: 2.5rem;
  font-family: var(--font-family-heading);
  color: #400C4D;
  font-weight: 700;
}

.section-heading p {
  margin: 0 0 2rem;
  color: #475569;
  font-size: 1.125rem;
  line-height: 1.6;
  max-width: 700px;
}

html[data-theme="dark"] .section-heading p {
  color: #94a3b8;
}

.modes-section {
  background: #f8f9fa;
  padding: 4rem 2rem;
  border-radius: 2rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  margin: 4rem auto;
  max-width: 1400px;
}

.modes-wrap {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: start;
}

@media (min-width: 1024px) {
  .modes-wrap {
    grid-template-columns: 1fr 1.5fr;
  }
}

.modes-left {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  text-align: center;
}

.modes-text h2 {
  margin: 0 0 1rem;
  font-size: 2.25rem;
  font-family: var(--font-family-heading);
  color: #400C4D;
  line-height: 1.2;
  font-weight: 700;
}

.modes-text p {
  margin: 0.5rem 0 0;
  color: #4f5a6b;
  line-height: 1.6;
  max-width: 420px;
}

.mode-illustration {
  width: 100%;
  max-width: 400px;
  aspect-ratio: 4/3;
  border-radius: 1.5rem;
  overflow: hidden;
  border: 2px solid #400C4D;
  background: #fff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
}

.mode-illustration img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hybrid-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.65rem 1.2rem;
  background: #d6c3d9;
  color: #400C4D;
  border-radius: 999px;
  font-weight: 600;
  width: fit-content;
  border-color: #400C4D;
}

.hybrid-icon {
  width: 28px;
  height: 28px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(64, 12, 77, 0.12);
  color: #400C4D;
}

.modes-right {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  justify-items: stretch;
}

.mode-card {
  background: #ffffff;
  padding: 2rem;
  border-radius: 1.35rem;
  border: 2px solid #400C4D;
  box-shadow: 0 26px 42px rgba(15, 23, 42, 0.15);
  display: flex;
  gap: 1.2rem;
  align-items: flex-start;
  min-height: 180px;
  min-width: 0;

}

.mode-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #F6EEF8;
  display: grid;
  place-items: center;
  color: #400C4D;
  flex-shrink: 0;
}

.mode-content h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.mode-content p {
  margin: 0.45rem 0 0;
  color: #400C4D;
  line-height: 1.55;
  font-size: 1rem;
}

html[data-theme="dark"] .modes-section {
  background: #071022;
  border-color: rgba(148, 163, 184, 0.18);
}

html[data-theme="dark"] .modes-text h2 {
  color: #e5e7eb;
}

html[data-theme="dark"] .modes-text p {
  color: #a3aab7;
}

html[data-theme="dark"] .hybrid-pill {
  background: rgba(89, 166, 255, 0.14);
  color: #9cc9ff;
}

html[data-theme="dark"] .hybrid-icon {
  background: rgba(89, 166, 255, 0.18);
  color: #9cc9ff;
}

html[data-theme="dark"] .mode-card {
  background: #0a0f1c;
  border-color: rgba(148, 163, 184, 0.18);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
}

html[data-theme="dark"] .mode-content h3 {
  color: #e5e7eb;
}

html[data-theme="dark"] .mode-content p {
  color: #a3aab7;
}

@media (max-width: 900px) {
  .modes-wrap {
    grid-template-columns: 1fr;
  }
  .modes-right {
    grid-template-columns: 1fr;
  }
  .modes-left {
    flex-direction: column;
    align-items: flex-start;
  }
  .mode-illustration {
    width: 100%;
    height: auto;
  }
}

.courses-section {
  max-width: 1400px;
  margin: 4rem auto;
  padding: 0 2rem;
}

.courses-section .section-heading h2 {
  margin: 0 0 0.4rem;
}

.courses-section .section-heading p {
  margin: 0 0 1.15rem;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin: 0;
  align-items: stretch;
}

.courses-grid .course-card {
  background: #d6c3d9;
  border-radius: 1.25rem;
  overflow: hidden;
  box-shadow: 0 10px 10px rgba(15, 23, 42, 0.12);
  border: 1px solid rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  border-color: #400C4D;
  min-width: 0;
  height: 100%;
}

.courses-grid .course-image {
  aspect-ratio: 4 / 3;
  min-height: 180px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.courses-grid .course-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.courses-grid .course-card .course-body {
  padding: 1.05rem 1rem 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
}

.courses-grid .course-card h3 {
  margin: 0.35rem 0 0.15rem;
  line-height: 1.2;
}

.courses-grid .course-card p {
  color: #475467;
  margin: 0;
  line-height: 1.45;
}

.courses-grid .course-card .course-cta {
  align-self: flex-start;
  margin-top: auto;
  padding: 0.55rem 1.35rem;
  border-radius: 999px;
  border: none;
  background: #400C4D;
  color: #fff;
  font-weight: 600;
  transition: transform 0.2s ease;
}

.courses-grid .course-card .course-cta:hover {
  transform: translateY(-2px);
  color: #f59e0b;
}

.cta-section {
  background: linear-gradient(135deg, #400C4D 0%, #5a1761 100%);
  color: #ffffff;
  max-width: 1200px;
  margin: 4rem auto 0;
  border-radius: 2rem;
  padding: 3rem 2.5rem;
  box-shadow: 0 20px 50px rgba(64, 12, 77, 0.3);
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  text-align: center;
}

@media (min-width: 768px) {
  .cta-section {
    grid-template-columns: 1.5fr 1fr;
    text-align: left;
  }
}

.cta-section > div:first-child {
  text-align: center;
}

.cta-section h2 {
  margin: 0;
  font-size: 2.3rem;
  font-family: var(--font-family-heading);
  font-weight: 800;
  line-height: 1.15;
  color: #ffffff;
}

.cta-section p {
  margin: 0.85rem auto 0;
  max-width: 620px;
  line-height: 1.6;
  font-size: 0.98rem;
  color: rgba(255, 255, 255, 0.95);
}

.cta-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

@media (min-width: 768px) {
  .cta-actions {
    justify-content: flex-end;
  }
}

.btn {
  border-radius: 12px;
  padding: 0.65rem 1.3rem;
  font-weight: 700;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 0.9rem;
  line-height: 1;
  transition: transform 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
}

#cta-journey {
  background: #400C4D;
}

.btn:hover {
  transform: translateY(-1px);
  color: #f59e0b;
  opacity: 0.96;
}

.btn.primary {
  background: #ffffff;
  color: #400C4D;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.15);
}

.btn.secondary {
  background: transparent;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 900px) {
  .cta-section {
    grid-template-columns: 1fr;
    row-gap: 1.2rem;
    padding: 2rem 1.5rem;
    margin: 2rem 1rem;
  }

  .cta-actions {
    justify-content: center;
    flex-wrap: wrap;
  }
}

html[data-theme="dark"] #cta-journey {
  background: #400C4D;
}

/* Force CTA secondary button to look like a button */
.cta-section .btn.secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0.65rem 1.3rem;
  border-radius: 12px;

  background: transparent;
  color: #ffffff;

  border: 1.5px solid rgba(255, 255, 255, 0.75);
  cursor: pointer;

  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1;
  white-space: nowrap;
}

.cta-section .btn.secondary:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #f59e0b;
}

@media (min-width: 1025px) and (max-width: 1400px) {
  .courses-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .courses-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .hero-content {
    padding: 2rem;
  }

  .metrics-section {
    padding: 1rem;
  }

  .courses-grid {
    grid-template-columns: 1fr;
  }

  .courses-grid .course-image {
    min-height: 220px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Home/home.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,aAAa;AACf;;AAEA,8CAA8C;AAC9C;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,gCAAgC;IAChC,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,uBAAuB;EACvB,mBAAmB;;EAEnB,uBAAuB;EACvB,cAAc;;EAEd,6CAA6C;EAC7C,eAAe;;EAEf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".home-page {\n  background: #ede9fe !important;\n  min-height: 100vh;\n  color: #0f172a;\n  padding-bottom: 3rem;\n  padding-top: 0;\n  margin-top: 0;\n}\n\n/* Override any parent container backgrounds */\nbody,\n.app,\n.main-content {\n  background: #ede9fe !important;\n}\n\nhtml[data-theme=\"dark\"] .home-page {\n  background: #02030a;\n  color: #e5e7eb;\n}\n\n.metrics-section {\n  max-width: 1200px;\n  margin: 3rem auto;\n  padding: 2rem;\n  background: #d6c3d9;\n  border-radius: 1.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 2rem;\n  box-shadow: 0 10px 30px rgba(64, 12, 77, 0.15);\n  border: 2px solid #c4b1c7;\n}\n\nhtml[data-theme=\"dark\"] .metrics-section {\n  background: #0b1220;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);\n  color: #e5e7eb;\n}\n\nhtml[data-theme=\"dark\"] .metric-label {\n  color: #a3aab7;\n}\n\nhtml[data-theme=\"dark\"] .metric-value {\n  color: #f8fafc;\n}\n\n.metric {\n  text-align: center;\n}\n\n.metric-value {\n  font-size: 2.25rem;\n  font-weight: 700;\n  margin: 0;\n  color: #400C4D;\n}\n\n.metric-label {\n  margin: 0;\n  letter-spacing: 0.2em;\n  font-size: 0.85rem;\n  color: #4c1d95;\n}\n\nhtml[data-theme=\"dark\"] .courses-section {\n  background: #05060c;\n}\n\n.section-heading {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.45rem;\n}\n\n.section-heading h2 {\n  margin: 0 0 0.75rem;\n  font-size: 2.5rem;\n  font-family: var(--font-family-heading);\n  color: #400C4D;\n  font-weight: 700;\n}\n\n.section-heading p {\n  margin: 0 0 2rem;\n  color: #475569;\n  font-size: 1.125rem;\n  line-height: 1.6;\n  max-width: 700px;\n}\n\nhtml[data-theme=\"dark\"] .section-heading p {\n  color: #94a3b8;\n}\n\n.modes-section {\n  background: #f8f9fa;\n  padding: 4rem 2rem;\n  border-radius: 2rem;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n  margin: 4rem auto;\n  max-width: 1400px;\n}\n\n.modes-wrap {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 3rem;\n  align-items: start;\n}\n\n@media (min-width: 1024px) {\n  .modes-wrap {\n    grid-template-columns: 1fr 1.5fr;\n  }\n}\n\n.modes-left {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n  text-align: center;\n}\n\n.modes-text h2 {\n  margin: 0 0 1rem;\n  font-size: 2.25rem;\n  font-family: var(--font-family-heading);\n  color: #400C4D;\n  line-height: 1.2;\n  font-weight: 700;\n}\n\n.modes-text p {\n  margin: 0.5rem 0 0;\n  color: #4f5a6b;\n  line-height: 1.6;\n  max-width: 420px;\n}\n\n.mode-illustration {\n  width: 100%;\n  max-width: 400px;\n  aspect-ratio: 4/3;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  border: 2px solid #400C4D;\n  background: #fff;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);\n}\n\n.mode-illustration img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.hybrid-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.65rem 1.2rem;\n  background: #d6c3d9;\n  color: #400C4D;\n  border-radius: 999px;\n  font-weight: 600;\n  width: fit-content;\n  border-color: #400C4D;\n}\n\n.hybrid-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  background: rgba(64, 12, 77, 0.12);\n  color: #400C4D;\n}\n\n.modes-right {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  justify-items: stretch;\n}\n\n.mode-card {\n  background: #ffffff;\n  padding: 2rem;\n  border-radius: 1.35rem;\n  border: 2px solid #400C4D;\n  box-shadow: 0 26px 42px rgba(15, 23, 42, 0.15);\n  display: flex;\n  gap: 1.2rem;\n  align-items: flex-start;\n  min-height: 180px;\n  min-width: 0;\n\n}\n\n.mode-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: #F6EEF8;\n  display: grid;\n  place-items: center;\n  color: #400C4D;\n  flex-shrink: 0;\n}\n\n.mode-content h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.mode-content p {\n  margin: 0.45rem 0 0;\n  color: #400C4D;\n  line-height: 1.55;\n  font-size: 1rem;\n}\n\nhtml[data-theme=\"dark\"] .modes-section {\n  background: #071022;\n  border-color: rgba(148, 163, 184, 0.18);\n}\n\nhtml[data-theme=\"dark\"] .modes-text h2 {\n  color: #e5e7eb;\n}\n\nhtml[data-theme=\"dark\"] .modes-text p {\n  color: #a3aab7;\n}\n\nhtml[data-theme=\"dark\"] .hybrid-pill {\n  background: rgba(89, 166, 255, 0.14);\n  color: #9cc9ff;\n}\n\nhtml[data-theme=\"dark\"] .hybrid-icon {\n  background: rgba(89, 166, 255, 0.18);\n  color: #9cc9ff;\n}\n\nhtml[data-theme=\"dark\"] .mode-card {\n  background: #0a0f1c;\n  border-color: rgba(148, 163, 184, 0.18);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);\n}\n\nhtml[data-theme=\"dark\"] .mode-content h3 {\n  color: #e5e7eb;\n}\n\nhtml[data-theme=\"dark\"] .mode-content p {\n  color: #a3aab7;\n}\n\n@media (max-width: 900px) {\n  .modes-wrap {\n    grid-template-columns: 1fr;\n  }\n  .modes-right {\n    grid-template-columns: 1fr;\n  }\n  .modes-left {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .mode-illustration {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.courses-section {\n  max-width: 1400px;\n  margin: 4rem auto;\n  padding: 0 2rem;\n}\n\n.courses-section .section-heading h2 {\n  margin: 0 0 0.4rem;\n}\n\n.courses-section .section-heading p {\n  margin: 0 0 1.15rem;\n}\n\n.courses-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin: 0;\n  align-items: stretch;\n}\n\n.courses-grid .course-card {\n  background: #d6c3d9;\n  border-radius: 1.25rem;\n  overflow: hidden;\n  box-shadow: 0 10px 10px rgba(15, 23, 42, 0.12);\n  border: 1px solid rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex-direction: column;\n  border-color: #400C4D;\n  min-width: 0;\n  height: 100%;\n}\n\n.courses-grid .course-image {\n  aspect-ratio: 4 / 3;\n  min-height: 180px;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n.courses-grid .course-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.courses-grid .course-card .course-body {\n  padding: 1.05rem 1rem 1.15rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.courses-grid .course-card h3 {\n  margin: 0.35rem 0 0.15rem;\n  line-height: 1.2;\n}\n\n.courses-grid .course-card p {\n  color: #475467;\n  margin: 0;\n  line-height: 1.45;\n}\n\n.courses-grid .course-card .course-cta {\n  align-self: flex-start;\n  margin-top: auto;\n  padding: 0.55rem 1.35rem;\n  border-radius: 999px;\n  border: none;\n  background: #400C4D;\n  color: #fff;\n  font-weight: 600;\n  transition: transform 0.2s ease;\n}\n\n.courses-grid .course-card .course-cta:hover {\n  transform: translateY(-2px);\n  color: #f59e0b;\n}\n\n.cta-section {\n  background: linear-gradient(135deg, #400C4D 0%, #5a1761 100%);\n  color: #ffffff;\n  max-width: 1200px;\n  margin: 4rem auto 0;\n  border-radius: 2rem;\n  padding: 3rem 2.5rem;\n  box-shadow: 0 20px 50px rgba(64, 12, 77, 0.3);\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n  .cta-section {\n    grid-template-columns: 1.5fr 1fr;\n    text-align: left;\n  }\n}\n\n.cta-section > div:first-child {\n  text-align: center;\n}\n\n.cta-section h2 {\n  margin: 0;\n  font-size: 2.3rem;\n  font-family: var(--font-family-heading);\n  font-weight: 800;\n  line-height: 1.15;\n  color: #ffffff;\n}\n\n.cta-section p {\n  margin: 0.85rem auto 0;\n  max-width: 620px;\n  line-height: 1.6;\n  font-size: 0.98rem;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.cta-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n@media (min-width: 768px) {\n  .cta-actions {\n    justify-content: flex-end;\n  }\n}\n\n.btn {\n  border-radius: 12px;\n  padding: 0.65rem 1.3rem;\n  font-weight: 700;\n  border: 1px solid transparent;\n  cursor: pointer;\n  font-size: 0.9rem;\n  line-height: 1;\n  transition: transform 0.15s ease, opacity 0.15s ease;\n  white-space: nowrap;\n}\n\n#cta-journey {\n  background: #400C4D;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n  color: #f59e0b;\n  opacity: 0.96;\n}\n\n.btn.primary {\n  background: #ffffff;\n  color: #400C4D;\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.15);\n}\n\n.btn.secondary {\n  background: transparent;\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.7);\n}\n\n@media (max-width: 900px) {\n  .cta-section {\n    grid-template-columns: 1fr;\n    row-gap: 1.2rem;\n    padding: 2rem 1.5rem;\n    margin: 2rem 1rem;\n  }\n\n  .cta-actions {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n\nhtml[data-theme=\"dark\"] #cta-journey {\n  background: #400C4D;\n}\n\n/* Force CTA secondary button to look like a button */\n.cta-section .btn.secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 0.65rem 1.3rem;\n  border-radius: 12px;\n\n  background: transparent;\n  color: #ffffff;\n\n  border: 1.5px solid rgba(255, 255, 255, 0.75);\n  cursor: pointer;\n\n  font-weight: 700;\n  font-size: 0.9rem;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.cta-section .btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: #f59e0b;\n}\n\n@media (min-width: 1025px) and (max-width: 1400px) {\n  .courses-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .courses-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-content {\n    padding: 2rem;\n  }\n\n  .metrics-section {\n    padding: 1rem;\n  }\n\n  .courses-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .courses-grid .course-image {\n    min-height: 220px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
